import { useState, useEffect } from 'react';
import qs from 'qs';

export default function usePortfolioFilters(data) {
  const [filters, setFilters] = useState(() => initFilters({ ...initialFilters }));

  useEffect(() => {
    if (data) {
      let count = 0;
      let outstanding = 0;
      for (let i = 0; i < data.length; i++) {
        const c = data[i];
        if (count < c.pbsOutstandingCountAll) {
          count = c.pbsOutstandingCountAll;
        }
        if (outstanding < c.pbsOutstandingAmountAll) {
          outstanding = c.pbsOutstandingAmountAll;
        }
      }
      const countMax = Math.max(1, count);
      const outstandingMax = Math.max(1, Math.round((outstanding + 1000) / 1000) * 1000);
      setFilters(old => ({
        ...old,
        countMax: { min: old.countMax.min || 0, max: countMax },
        outstandingDebt: { min: 0, max: outstandingMax },
        initCountMax: Math.max(countMax, old.countMax.min),
        initOutstandingMax: outstandingMax
      }));
    }
  }, [data]);

  const updateFilter = (name, value) => {
    setFilters(old => ({ ...old, [name]: value }));
  };

  return [filters, updateFilter];
}

const initFilters = initial => {
  let params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  return Object.keys(params).reduce((res, entry) => {
    if (entry === 'outstandingCountMin') {
      res.countMax.min = Number(params[entry]);
    } else if (params[entry] === 'true') {
      res[entry] = true;
    } else if (params[entry] === 'false') {
      res[entry] = false;
    }
    return res;
  }, initial);
};

const initialFilters = {
  individual: false,
  company: false,
  veryLowRisk: false,
  lowRisk: false,
  possibleRisk: false,
  highRisk: false,
  cipNotCalculated: false,
  notOnDDRegistry: false,
  sevGroup1: false,
  sevGroup2: false,
  sevGroup3: false,
  sevGroupOther: false,
  payment0: false,
  payment10: false,
  payment20: false,
  payment20Plus: false,
  deceased: false,
  countMax: { min: 0, max: 10 },
  outstandingDebt: { min: 0, max: 10 },
  initCountMax: 10,
  initOutstandingMax: 10
};
